
























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { BannerInfo, Borough, RegionLogo } from "@/model/Boroughs";
import DrinkCoachLogo from "../assets/regions/DrinkCoach-logo.svg";
import { LogEvent } from "@/utils";
import { UserInteractionEvent } from "@/model/UserEvents";
import { RiskLevel } from "@/model/RiskLevel";

const DrinkCoach: RegionLogo = {
  file: DrinkCoachLogo,
  width: 75,
  height: 75
};

@Component
export default class RegionBanner extends Vue {
  @Prop() private info!: BannerInfo;
  @Prop() private region!: Borough;
  @Prop() private currentStep!: number;
  @Prop() private testCompleted!: boolean;
  @Prop({ default: null }) private riskLevel!: RiskLevel | null;
  @Prop() private isMobile!: boolean;

  private get hasText(): boolean {
    return (
      (this.currentStep !== 0 || this.testCompleted) && this.info.rawCopy !== ""
    );
  }

  private get text(): string {
    if (this.isFirstStep) {
      return "";
    }
    return this.info.rawCopy;
  }

  private get isFirstStep(): boolean {
    return this.currentStep === 0 && !this.testCompleted;
  }

  private get regionName(): string {
    if (this.isFirstStep) {
      return "";
    }
    return this.region.name.toLowerCase().replace(/ /g, "-");
  }

  private get logo(): RegionLogo {
    if (this.isFirstStep) {
      return DrinkCoach;
    }
    if (this.region.logoHigher && this.riskLevel === RiskLevel.Higher) {
      return this.region.logoHigher;
    } else if (this.region.logoHigh && this.riskLevel === RiskLevel.High) {
      return this.region.logoHigh;
    } else if (this.region.logoIncreasing && this.riskLevel === RiskLevel.Increasing) {
      return this.region.logoIncreasing;
    } else if (this.region.logoLower && this.riskLevel === RiskLevel.Lower) {
      return this.region.logoLower;
    }
    return this.region.logo || DrinkCoach;
  }

  @Emit("navigate")
  private gotoFindSupport() {
    return "find-support";
  }

  private handleBannerClick(event: Event) {
    if (!this.hasText) {
      event.preventDefault();
      return;
    }
    if (this.info.logoLink === "find-support") {
      event.preventDefault();
      this.gotoFindSupport();
    } else {
      // Default action
      LogEvent(
        UserInteractionEvent.LaunchUrl,
        (event.currentTarget as HTMLAnchorElement).href
      );
    }
  }
}
